function DashBoardPage() {
  return <h1>DashBoard</h1>;
}

export default DashBoardPage;
